import { render, staticRenderFns } from "./EnhanceMenu.vue?vue&type=template&id=78ab65f5"
import script from "./EnhanceMenu.vue?vue&type=script&lang=ts"
export * from "./EnhanceMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports